/* ============================================================
   QUELL — Home hero image carousel.
   Auto-advances the right-side slides with a horizontal slide,
   dot indicators, pause on hover/focus and when the tab is
   hidden. Respects prefers-reduced-motion (no auto-advance,
   no slide animation) and re-inits inside the Theme editor.
   Markup is server-rendered in sections/home-hero.liquid.
   ============================================================ */
(function () {
  "use strict";
  if (window.__heroCarousel) return;
  window.__heroCarousel = true;

  var reduce =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function init(root) {
    if (!root || root.dataset.hcInit === "1") return;
    var track = root.querySelector(".hero-track");
    var slides = root.querySelectorAll(".hero-slide");
    var dots = root.querySelectorAll(".hero-dot");
    if (!track || slides.length < 2) return; // single slide → static
    root.dataset.hcInit = "1";

    var n = slides.length;
    var i = 0;
    var timer = null;
    var autoplay = root.dataset.autoplay !== "false" && !reduce;
    var interval = parseInt(root.dataset.interval, 10) || 5000;

    function go(next) {
      i = (next + n) % n;
      track.style.transform = "translateX(" + -i * 100 + "%)";
      slides.forEach(function (slide, s) {
        slide.setAttribute("aria-hidden", s === i ? "false" : "true");
      });
      dots.forEach(function (dot, d) {
        var on = d === i;
        dot.classList.toggle("is-active", on);
        if (on) dot.setAttribute("aria-current", "true");
        else dot.removeAttribute("aria-current");
      });
    }

    function start() {
      if (!autoplay || timer) return;
      timer = setInterval(function () {
        go(i + 1);
      }, interval);
    }
    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }
    function restart() {
      stop();
      start();
    }

    dots.forEach(function (dot, idx) {
      dot.addEventListener("click", function () {
        go(idx);
        restart();
      });
    });

    // Pause while the visitor is interacting or the tab is backgrounded.
    root.addEventListener("mouseenter", stop);
    root.addEventListener("mouseleave", start);
    root.addEventListener("focusin", stop);
    root.addEventListener("focusout", start);
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) stop();
      else start();
    });

    go(0);
    start();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll("[data-hero-carousel]").forEach(init);
  }

  var TYPE_MIN = 0.8;
  var SPACE_MIN = 0.7;
  var CTA_MIN = 0.72;
  var STATS_MIN = 0.75;

  function fit(section) {
    if (!section) return;
    var copy = section.querySelector(".copy");
    var shot = section.querySelector(".shot");
    if (!copy || !shot) return;

    section.style.setProperty("--fit-space", "1");
    section.style.setProperty("--fit-type", "1");
    shot.style.minHeight = "";

    if (window.matchMedia && window.matchMedia("(max-width: 900px)").matches)
      return;
    if (!shot.clientWidth) return;

    function tooTall() {
      return (
        copy.getBoundingClientRect().height >
        shot.getBoundingClientRect().height + 0.5
      );
    }
    if (!tooTall()) return;

    var v = 1;
    while (tooTall() && v > TYPE_MIN) {
      v -= 0.02;
      section.style.setProperty("--fit-type", v.toFixed(2));
    }
    v = 1;
    while (tooTall() && v > SPACE_MIN) {
      v -= 0.05;
      section.style.setProperty("--fit-space", v.toFixed(2));
    }
    if (tooTall())
      shot.style.minHeight = copy.getBoundingClientRect().height + "px";
  }

  function fitRow(section, selector, prop, min) {
    var el = section.querySelector(selector);
    if (!el) return;
    section.style.setProperty(prop, "1");
    if (window.matchMedia && window.matchMedia("(max-width: 900px)").matches)
      return;
    var v = 1;
    while (el.scrollWidth > el.clientWidth + 1 && v > min) {
      v -= 0.03;
      section.style.setProperty(prop, v.toFixed(2));
    }
  }

  function fitAll(scope) {
    (scope || document).querySelectorAll(".s-home-hero").forEach(function (s) {
      fitRow(s, ".cta", "--fit-cta", CTA_MIN);
      fitRow(s, ".specrow", "--fit-stats", STATS_MIN);
      fit(s);
    });
  }

  var fitTimer = null;
  function fitSoon() {
    clearTimeout(fitTimer);
    fitTimer = setTimeout(function () {
      fitAll(document);
    }, 150);
  }

  function ready(fn) {
    if (document.readyState === "loading")
      document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  ready(function () {
    initAll(document);
    fitAll(document);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        fitAll(document);
      });
    }
    window.addEventListener("resize", fitSoon);
  });

  // Theme editor: the section DOM is replaced on load/select, so re-init.
  document.addEventListener("shopify:section:load", function (e) {
    initAll(e.target);
    fitAll(document);
  });
  document.addEventListener("shopify:section:select", function (e) {
    initAll(e.target);
  });
})();
